import { ReactNode } from "react";

interface Floating3DProps {
  children: ReactNode;
  intensity?: number;
  className?: string;
}

export default function Floating3D({ 
  children, 
  // intensity = 0,
  // className = '' 
}: Floating3DProps) {
  // const ref = use3DParallax({ intensity });

  return (
    <div
      // ref={ref}
      // className={`transform-gpu ${className}`}
      // style={{ transformStyle: 'preserve-3d' }}
    >
      {children}
    </div>
  );
}














